'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Cell = require('./Cell');

var _Cell2 = _interopRequireDefault(_Cell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('fixed-data-table-2'),
    Table = _require.Table,
    Column = _require.Column,
    Cell = _require.Cell;

var ReactTable = function (_Component) {
	_inherits(ReactTable, _Component);

	function ReactTable(props) {
		_classCallCheck(this, ReactTable);

		var _this = _possibleConstructorReturn(this, (ReactTable.__proto__ || Object.getPrototypeOf(ReactTable)).call(this, props));

		_this.width = document.querySelector('#react-table').offsetWidth;
		return _this;
	}

	_createClass(ReactTable, [{
		key: 'render',
		value: function render() {
			var data = window.TABLE_DATA;
			return _react2.default.createElement(
				Table,
				{
					rowHeight: 50,
					headerHeight: 50,
					rowsCount: data.length,
					width: this.width,
					height: 500
				},
				this.renderColumns(data)
			);
		}
	}, {
		key: 'renderColumns',
		value: function renderColumns(data) {
			var _this2 = this;

			var columnTitles = Object.keys(data[0]);

			return columnTitles.map(function (title, i) {
				return _react2.default.createElement(Column, {
					key: title,
					columnKey: title,
					header: _this2.headerCell(title),
					cell: _react2.default.createElement(_Cell2.default, { data: data }),
					width: 150
				});
			});
		}
	}, {
		key: 'headerCell',
		value: function headerCell(title) {
			return _react2.default.createElement(
				Cell,
				null,
				this.formatTitle(title)
			);
		}
	}, {
		key: 'formatTitle',
		value: function formatTitle(title) {
			return title.split("_").map(function (text) {
				return text[0].toUpperCase() + text.substring(1);
			}).join(" ");
		}
	}]);

	return ReactTable;
}(_react.Component);

exports.default = ReactTable;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/reports/ReactTable.js
// module id = 520
// module chunks = 0